import DataContainer from 'Util/Request/DataContainer';
import { connect } from 'react-redux';

import BlackFriday from './BlackFriday.component';

import { toggleBreadcrumbs } from 'Store/Breadcrumbs/Breadcrumbs.action';
import { updateMeta } from 'Store/Meta/Meta.action';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import { CMS_PAGE } from 'Component/Header/Header.config';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import CmsPageQuery from 'Query/CmsPage.query';
import { history } from 'Route';

export const mapDispatchToProps = dispatch => ({
    toggleBreadcrumbs: state => dispatch(toggleBreadcrumbs(state)),
    updateMeta: meta => dispatch(updateMeta(meta)),
    setHeaderState: stateName => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, stateName))
});

export class BlackFridayContainer extends DataContainer {
    state = {
        page: {},
        isLoading: true
    };

    componentDidMount() {
        this._removeBreadcrumbs();
        this._changeHeaderState();

        this.requestPage();
    }

    containerProps = () => {
        const { page, isLoading } = this.state;
        const { menu } = this.props;

        return {
            page,
            isLoading,
            menu
        };
    };

    _removeBreadcrumbs() {
        const { toggleBreadcrumbs } = this.props;

        toggleBreadcrumbs(false);
    }

    _changeMeta(title, metaTitle, content_heading) {
        const { updateMeta, setHeaderState } = this.props;

        updateMeta({ title: metaTitle || title });

        setHeaderState({
            name: CMS_PAGE,
            title: content_heading,
            onBackClick: () => history.goBack()
        })
    }

    _changeHeaderState() {
        const { setHeaderState } = this.props;

        setHeaderState({
            name: CMS_PAGE,
            onBackClick: () => history.goBack()
        });
    }

    onPageError = () => {
        this.setState({ isLoading: false });

        history.push('/');
    }

    onPageLoad = ({ cmsPage: page }) => {
        const { content_heading, title, meta_title } = page;

        this.setState({ page, isLoading: false });
        this._changeMeta(title, meta_title, content_heading)
    };

    requestPage() {
        const { slug } = this.props;

        this.setState({ isLoading: true });

        this.fetchData(
            [CmsPageQuery.getQuery({ identifier: slug })],
            this.onPageLoad,
            this.onPageError
        );
    }

    render() {
        return (
            <BlackFriday
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(null, mapDispatchToProps)(BlackFridayContainer);
